import { styled, Dialog, DialogContent, DialogTitle } from '@mui/material'
export const AccountLoginAlertBanner = styled('div')`
  width: 100%;
  background: #ff6600;
  padding: 0.5em;
  margin: 0.5em;
  color: whitesmoke;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25em;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`

export const ListAutoCompleteWrapper = styled('div')`
  padding: 0.5em;
  margin: 0.25em 0;
`
export const AboutScopeTitle = styled('h6')`
  padding: 0.5em 1em 0 1em;
  margin: 0.5em 0 0 0;
  font-size: 0.95em;
  text-align: left;
  font-weight: bold;
  margin-bottom: 0.25em;
`
export const ScopeDetailText = styled('p')`
  padding: 0 1em;
  margin: 0.25em 0;
  font-size: 0.9em;
  text-align: justify;

  ul {
    margin-top: 0.5em;
  }

  li {
    margin-top: 0.5em;
    margin-left: 2em;
  }
`
